import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';
import * as net from 'util/Net';

import {DataPolicy, PolicySpec} from './PolicyConstants';
import * as PolicyDAO from './PolicyDAO';

export enum PolicyActionType {
  POLICIES_BOOTSTRAPPED = 'POLICIES_BOOTSTRAPPED',
  DATA_POLICY_UPDATED = 'DATA_POLICY_UPDATED',
}

export interface PoliciesBoostrappedAction {
  type: PolicyActionType.POLICIES_BOOTSTRAPPED;
  dataPolicies: Array<DataPolicy>;
}

export function policiesBootstrapped(dataPolicies: Array<DataPolicy>): PoliciesBoostrappedAction {
  return {
    type: PolicyActionType.POLICIES_BOOTSTRAPPED,
    dataPolicies,
  };
}

export async function getDataPolicies(): Promise<PolicyDAO.DataPoliciesResponse> {
  const result = await PolicyDAO.getDataPolicies();
  getStore().dispatch(policiesBootstrapped(result.dataPolicies));
  return result;
}

export async function cloneDataPolicy(dataPolicyId: string, name: string): Promise<void> {
  await PolicyDAO.cloneDataPolicy(dataPolicyId, name);
  await getDataPolicies();
}

export interface DataPolicyUpdatedAction {
  type: PolicyActionType.DATA_POLICY_UPDATED;
  dataPolicy: DataPolicy;
}

export function dataPolicyUpdated(dataPolicy: DataPolicy): DataPolicyUpdatedAction {
  return {
    type: PolicyActionType.DATA_POLICY_UPDATED,
    dataPolicy,
  };
}

export async function updateDataPolicy(
  dataPolicyId: string,
  spec: PolicySpec
): Promise<{spec: PolicySpec | null}> {
  try {
    const result = await PolicyDAO.updateDataPolicy(dataPolicyId, spec);
    notifications.close('PolicyReduxActions.updateDataPolicy');
    getStore().dispatch(dataPolicyUpdated(result.dataPolicy));
    return {spec: result.spec};
  } catch (err) {
    if (net.isServerRequestError(err)) {
      notifications.notifyError(err, {id: 'PolicyReduxActions.updateDataPolicy'});
      return {spec: null};
    }
    throw err;
  }
}

export async function updateDataPolicies(dataPolicies: Array<PolicyDAO.DataPolicyUpdate>): Promise<void> {
  const result = await PolicyDAO.updateDataPolicies(dataPolicies);
  policiesBootstrapped(result.dataPolicies);
}

export async function deleteDataPolicy(dataPolicyId: string): Promise<void> {
  await PolicyDAO.deleteDataPolicy(dataPolicyId);
  await getDataPolicies();
}

export async function reorderDataPolicies(dataPolicyIds: Array<string>): Promise<void> {
  const result = await PolicyDAO.reorderDataPolicies(dataPolicyIds);
  getStore().dispatch(policiesBootstrapped(result.dataPolicies));
}

export type PolicyAction = PoliciesBoostrappedAction | DataPolicyUpdatedAction;
